export const deployUrl = () => {
  if (typeof DEPLOY_URL === 'undefined') {
    return '/';
  }

  return DEPLOY_URL;
};
